import { render, staticRenderFns } from "./supplierEdit.vue?vue&type=template&id=53e31c2a&scoped=true&"
import script from "./supplierEdit.vue?vue&type=script&lang=js&"
export * from "./supplierEdit.vue?vue&type=script&lang=js&"
import style0 from "./supplierEdit.vue?vue&type=style&index=0&id=53e31c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e31c2a",
  null
  
)

export default component.exports